import { App, computed } from 'vue';
import pinia from 'store';
import useI18n, { useT } from 'core/i18n';
import { useMitt } from 'app/hook/mitt';
// 注冊svg雪碧图
import 'virtual:svg-icons-register';
import { useLazyLoad } from 'app/hook/lazyload';
import { useAppStore } from 'store/modules/appStore';
import useFingerprint from 'app/hook/fingerprint';

// 在开发环境中加载时间同步调试工具
// @ts-ignore
// if (import.meta.env.DEV) {
//     import('utils/timeSyncDebug');
// }

// 引入组件样式
import 'vant/lib/index.css';
// 引入toast样式，否则无样式
import 'vant/es/toast/style';
import usePwaClient from 'core/hooks/usePwaClient';
import { getTheme, loadTheme, updateThemeColorMeta } from 'web_v2/src/styles/theme';
import user from 'service/user';
import { useUserStore } from 'store/modules/userStore';
import { loadGoogleAnalytics } from './googleAnalytics.config';
// import { useRegisterSW } from 'virtual:pwa-register/vue';
import { useRealtimeDatabase } from 'app/hook/useRealtimeDatabase';
import { initFirebase } from 'app/hook/firebase/index';
// import { initSentry } from './sentry';
import LazyPreloadPlugin from 'app/directives/v-lazy-preload';

export async function bootstrap(app: App) {
    // initSentry(app);

    console.log('初始化 Firebase 核心服务');
    await initFirebase();

    console.log('初始化 Realtime Database');
    useRealtimeDatabase();
    // pinia
    app.use(pinia);

    // 初始化进入的时候就存储一个webDomain 保留所有的参数
    const webDomain = window.location.href;
    localStorage.setItem('webDomain', webDomain); // 保留所有的参数

    // 初始化网络时间同步（在应用启动时立即开始同步）
    // console.log('正在初始化网络时间同步...');
    // try {
    //     await initTimeSync();
    //     console.log('✅ 网络时间同步初始化成功');
    // } catch (error) {
    //     console.warn('❌ 网络时间同步初始化失败，将使用本地时间:', error);
    // }

    const { getUrlParam } = usePwaClient();
    const theme = getUrlParam('theme');
    if (theme) {
        localStorage.setItem('h5_theme', theme);
    } else {
        localStorage.removeItem('h5_theme');
    }

    // 加载主题
    loadTheme();

    // 启动时更新主题色meta标签
    updateThemeColorMeta(getTheme());

    // 地址栏是否携带google=1
    const google = getUrlParam('google');
    if (google) {
        localStorage.setItem('google', '1');
    } else {
        localStorage.removeItem('google');
    }

    // 是否在被嵌入的页面中
    const embedded = getUrlParam('embedded');
    if (embedded) {
        localStorage.setItem('embedded', '1');
    }

    const iframeDomain = getUrlParam('domain');
    if (iframeDomain) {
        localStorage.setItem('iframe_domain', iframeDomain);
    }

    const sdmodeFromUrl = getUrlParam('sdmode');
    if (sdmodeFromUrl === '2') {
        localStorage.setItem('sdmode', '2');
    }

    // 检查URL中是否包含token和refresh_token参数，如果有则保存到localStorage
    const pwaToken = getUrlParam('token');
    if (pwaToken) {
        localStorage.setItem('pwaToken', pwaToken);
    }
    const pwaTokenLogin = localStorage.getItem('pwaTokenLogin');

    if (pwaToken && !pwaTokenLogin) {
        // 使用pwaToken去请求登录
        try {
            const result = await user.pwaTokenLogin({ key: pwaToken });
            if (result.code === 0 && result.data) {
                const userStore = useUserStore();
                userStore.saveToken(result.data);
                // 标记一下已经做过登录了
                localStorage.setItem('pwaTokenLogin', '1');
                // console.log('登录成功', result.data);
            }
        } catch (e) {
            console.log(e, '=======e');
        }
    }

    // mitt
    app.provide('mitt', useMitt());

    const appStore = useAppStore();

    // TODO: 可以在这里做一些初始化的操作 比如实例化之前需要请求的接口 获取配置信息 等等的操作 都可以在这里调用
    await appStore.handleGetLanguage();
    await appStore.handleGetSystemData(appStore.language!);

    // 渠道id获取apk下载地址
    const fb_pixel_id = getUrlParam('fb_pixel_id');
    if (fb_pixel_id) {
        appStore.getPromotionTemplateChannel({ id: fb_pixel_id });
    }

    const systemData = computed(() => appStore.getSystemData);

    // 加载 Google Analytics
    const siteId = appStore.getSystemData?.aliasNum;
    if (siteId) {
        loadGoogleAnalytics(siteId);
    }

    const preloadIcon = systemData.value?.preloadIcon || '';

    // 图片懒加载
    app.use(useLazyLoad(), {
        // loading: (loadingImg[aliasNum as keyof typeof loadingImg] as any) || loadingImg['any'],
        loading: preloadIcon,
        error: new URL('../../images/common/404.jpg', import.meta.url).href,
        log: false,
    });

    app.use(LazyPreloadPlugin, {
        loading: preloadIcon, // 加载中占位图
        error: new URL('../../images/common/404.jpg', import.meta.url).href, // 错误图
        log: false, // 是否输出日志（开发时可设为 true）
    });

    const i18n = await useI18n(appStore.language!);

    await useFingerprint();

    const t = useT();
    // console.log(t('测试'), '--------多语言');
    // print(useT());
    // 多语言
    app.use(i18n);
}
